import { Box, Container, Grid, Typography } from '@mui/material';
import { styled } from '@mui/material/styles';
import Page from 'src/components/Page';
import { RegisterForm } from 'src/portals/components/auth/register';
import BackgroundImage from 'src/assets/LightLogoLightGreen.svg';

const RootStyle = styled('div')(({ theme }) => ({
  minHeight: '100vh',
  paddingTop: theme.spacing(11),
  paddingBottom: theme.spacing(7),
  backgroundImage: `url(${BackgroundImage})`,
  backgroundRepeat: 'no-repeat',
  backgroundSize: 'cover',
  backgroundColor: theme.palette.common.black,
}));

const ContentBox = styled(Box)(({ theme }) => ({
  backgroundColor: theme.palette.primary.main,
  opacity: '0.95',
  borderRadius: theme.spacing(1),
  padding: theme.spacing(2),
  [theme.breakpoints.down('lg')]: {
    padding: theme.spacing(4),
  },
}));

export default function RegisterCustomer({ partnerMode }: { partnerMode: boolean }) {
  return (
    <Page title="Libertas - Tactical Capital">
      <RootStyle role={'main'}>
        <Container maxWidth="lg">
          <Grid container justifyContent="space-between">
            <Grid
              item
              xs={12}
              md={6}
              lg={6}
              sx={{
                backgroundColor: 'rgba(56, 80, 55, 0.9)',
                padding: '2.5rem',
                borderRadius: '10px',
                display: 'flex',
                flexDirection: 'column',
                mb: { xs: 3, md: 0 },
              }}
            >
              <Typography
                variant="h3"
                sx={{
                  color: 'common.white',
                  textAlign: 'center',
                  fontFamily: (theme) => theme.typography.h3.fontFamily,
                  textTransform: 'uppercase',
                  mb: 2,
                }}
              >
                {partnerMode ? 'Partner Registration' : 'Seize Growth Opportunities'}
              </Typography>
              <RegisterForm
                role={partnerMode ? 'iso' : 'customer'}
                isExistingClient={partnerMode}
                showLegalAgreements={true}
              />
            </Grid>
            <Grid item xs={12} md={5.5} lg={5.5}>
              <ContentBox
                sx={{
                  backgroundColor: 'rgba(56, 80, 55, 0.9)',
                  padding: '2.5rem',
                }}
              >
                <Typography
                  variant="h2"
                  sx={{
                    color: 'common.white',
                    fontWeight: 700,
                    mb: 3,
                  }}
                >
                  {partnerMode
                    ? 'Strategic Growth Partners'
                    : 'The tactical funding partner fueling business momentum'}
                </Typography>

                {partnerMode ? (
                  <Typography
                    variant="body1"
                    sx={{
                      color: 'common.white',
                      lineHeight: 1.6,
                    }}
                  >
                    We provide rapid capital to secure the advantage for big-move-makers. Our
                    sophisticated senior team delivers institutional-caliber business intelligence
                    with unmatched transaction speed enabled by proprietary underwriting technology.
                  </Typography>
                ) : (
                  <>
                    <Typography
                      variant="body1"
                      sx={{
                        color: 'common.white',
                        mb: 3,
                        lineHeight: 1.6,
                      }}
                    >
                      Access $500K-$10M in short-term, revenue-based financing that moves at the
                      speed of your business. Our capital closes the critical gap between businesses
                      and their next move.
                    </Typography>

                    <Typography
                      variant="h6"
                      sx={{
                        color: 'common.white',
                        mb: 2,
                        fontFamily: (theme) => theme.typography.body1.fontFamily,
                        fontWeight: 600,
                        textTransform: 'uppercase',
                        letterSpacing: '-0.02em',
                      }}
                    >
                      Why Choose Libertas
                    </Typography>

                    <Box component="ul" sx={{ color: 'common.white', pl: 2, m: 0 }}>
                      <Typography component="li" variant="body2" sx={{ mb: 1, lineHeight: 1.6 }}>
                        Direct short-term lending for healthy businesses to act on growth
                        opportunities
                      </Typography>
                      <Typography component="li" variant="body2" sx={{ mb: 1, lineHeight: 1.6 }}>
                        Unmatched transaction speed enabled by proprietary underwriting technology
                      </Typography>
                      <Typography component="li" variant="body2" sx={{ mb: 1, lineHeight: 1.6 }}>
                        Sophisticated senior team with institution-caliber business intelligence
                      </Typography>
                      <Typography component="li" variant="body2" sx={{ lineHeight: 1.6 }}>
                        High-touch, hands-on process that results in real relationships
                      </Typography>
                    </Box>
                  </>
                )}
              </ContentBox>
            </Grid>
          </Grid>
        </Container>
      </RootStyle>
    </Page>
  );
}
